// todo - change to boolean!
export enum EanCodesAvailable {
    Known = 'known',
    Unknown = 'unknown',
}
